import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Coins, Check } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/lib/AuthContext";

const PACKAGES = [
  { id: "50", coins: 50, price: 200 },
  { id: "100", coins: 100, price: 400, popular: true },
  { id: "200", coins: 200, price: 600 },
];

export default function CoinPurchaseModal({ open, onClose }) {
  const { refresh } = useAuth();
  const [loading, setLoading] = useState(null);
  const buy = async (id) => {
    setLoading(id);
    try {
      const r = await api.post("/coins/purchase", { package: id });
      await refresh();
      toast.success(`✓ ${r.data.coins_added} coins added (Test mode)`);
      onClose();
    } catch { toast.error("Purchase failed"); }
    finally { setLoading(null); }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="rounded-3xl max-w-2xl border-border" data-testid="coin-purchase-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-black tracking-tight flex items-center gap-2">
            <Coins className="w-7 h-7 text-primary" /> Buy coins
          </DialogTitle>
          <DialogDescription>Unlock tutor contacts and boosted listings.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
          {PACKAGES.map(p => (
            <div key={p.id} className={`relative rounded-2xl p-5 border-2 ${p.popular ? "border-primary bg-primary/5" : "border-border"}`}>
              {p.popular && (
                <div className="absolute -top-3 left-4 bg-primary text-primary-foreground text-[10px] uppercase tracking-widest px-3 py-1 rounded-full">Popular</div>
              )}
              <div className="font-display text-4xl font-black">{p.coins}</div>
              <div className="text-sm text-muted-foreground mb-3">coins</div>
              <div className="font-display text-2xl font-bold">₹{p.price}</div>
              <ul className="text-xs text-muted-foreground mt-4 space-y-1.5">
                <li className="flex gap-1.5"><Check className="w-3.5 h-3.5 text-primary" /> {Math.floor(p.coins / 10)} contact reveals</li>
                <li className="flex gap-1.5"><Check className="w-3.5 h-3.5 text-primary" /> Boosted listing (teachers)</li>
              </ul>
              <Button onClick={() => buy(p.id)} disabled={loading} data-testid={`buy-package-${p.id}`}
                className={`w-full mt-5 rounded-full h-11 ${p.popular ? "bg-primary hover:bg-primary/90" : "bg-foreground text-background hover:opacity-80"}`}>
                {loading === p.id ? "Processing…" : "Buy now"}
              </Button>
            </div>
          ))}
        </div>
        <div className="mt-4 text-xs text-center text-muted-foreground bg-muted rounded-xl p-3">
          <strong>TEST MODE:</strong> Payments are simulated. Real Razorpay activates once API keys are provided.
        </div>
      </DialogContent>
    </Dialog>
  );
}
